import { createFileRoute } from '@tanstack/react-router';

import { TargetingBuilderPage } from '../features/targeting/builder/TargetingBuilderPage';
import { targetingBuilderRouteSearchSchema } from '../features/targeting/builder/targetingBuilderRouteSearch';

export const Route = createFileRoute('/targeting/')({
  validateSearch: targetingBuilderRouteSearchSchema,
  component: TargetingBuilderPage,
});
